module.exports = "/work-site/img/geojson.992a6c13.png";